const heAction = action => `HIGHER_ED/${action}`;

const RUN_ASSESSMENT = heAction('RUN_ASSESSMENT');
const RUN_ASSESSMENT_SUCCESS = heAction('RUN_ASSESSMENT_SUCCESS');
const RUN_ASSESSMENT_FAILURE = heAction('RUN_ASSESSMENT_FAILURE');

const GET_ASSESSMENTS = heAction('GET_ASSESSMENTS');
const GET_ASSESSMENTS_SUCCESS = heAction('GET_ASSESSMENTS_SUCCESS');
const GET_ASSESSMENTS_FAILURE = heAction('GET_ASSESSMENTS_FAILURE');

// Client-side draft state — student / faculty role characteristics + ratings
// kept in Redux so the user can navigate between dashboard and rating without
// losing partial input. Persisted to localStorage in the saga.
const SET_DRAFT = heAction('SET_DRAFT');
const HYDRATE_DRAFT = heAction('HYDRATE_DRAFT');

// Top N feature recommendations for the latest assessment (used by the PDF).
const GET_TOP_FEATURES = heAction('GET_TOP_FEATURES');
const GET_TOP_FEATURES_SUCCESS = heAction('GET_TOP_FEATURES_SUCCESS');
const GET_TOP_FEATURES_FAILURE = heAction('GET_TOP_FEATURES_FAILURE');

// Higher Ed surveys -- Block A student-rating collection (phase 2, 2026-06-28).
const GET_SURVEYS = heAction('GET_SURVEYS');
const GET_SURVEYS_SUCCESS = heAction('GET_SURVEYS_SUCCESS');
const GET_SURVEYS_FAILURE = heAction('GET_SURVEYS_FAILURE');

const CREATE_SURVEY = heAction('CREATE_SURVEY');
const CREATE_SURVEY_SUCCESS = heAction('CREATE_SURVEY_SUCCESS');
const CREATE_SURVEY_FAILURE = heAction('CREATE_SURVEY_FAILURE');

const GET_SURVEY_DETAILS = heAction('GET_SURVEY_DETAILS');
const GET_SURVEY_DETAILS_SUCCESS = heAction('GET_SURVEY_DETAILS_SUCCESS');
const GET_SURVEY_DETAILS_FAILURE = heAction('GET_SURVEY_DETAILS_FAILURE');
const RESET_SURVEY_DETAILS = heAction('RESET_SURVEY_DETAILS');

const ANSWER_SURVEY = heAction('ANSWER_SURVEY');
const ANSWER_SURVEY_SUCCESS = heAction('ANSWER_SURVEY_SUCCESS');
const ANSWER_SURVEY_FAILURE = heAction('ANSWER_SURVEY_FAILURE');

const REMOVE_SURVEY = heAction('REMOVE_SURVEY');
const REMOVE_SURVEY_SUCCESS = heAction('REMOVE_SURVEY_SUCCESS');
const REMOVE_SURVEY_FAILURE = heAction('REMOVE_SURVEY_FAILURE');

export default {
  RUN_ASSESSMENT, RUN_ASSESSMENT_SUCCESS, RUN_ASSESSMENT_FAILURE,
  GET_ASSESSMENTS, GET_ASSESSMENTS_SUCCESS, GET_ASSESSMENTS_FAILURE,
  SET_DRAFT, HYDRATE_DRAFT,
  GET_TOP_FEATURES, GET_TOP_FEATURES_SUCCESS, GET_TOP_FEATURES_FAILURE,
  GET_SURVEYS, GET_SURVEYS_SUCCESS, GET_SURVEYS_FAILURE,
  CREATE_SURVEY, CREATE_SURVEY_SUCCESS, CREATE_SURVEY_FAILURE,
  GET_SURVEY_DETAILS, GET_SURVEY_DETAILS_SUCCESS, GET_SURVEY_DETAILS_FAILURE, RESET_SURVEY_DETAILS,
  ANSWER_SURVEY, ANSWER_SURVEY_SUCCESS, ANSWER_SURVEY_FAILURE,
  REMOVE_SURVEY, REMOVE_SURVEY_SUCCESS, REMOVE_SURVEY_FAILURE,
};
